var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 16V17.4286C11.4286 17.902 11.0448 18.2857 10.5714 18.2857H0.857143C0.38375 18.2857 0 17.902 0 17.4286V4.28571C0 3.81232 0.38375 3.42857 0.857143 3.42857H3.42857V14C3.42857 15.1028 4.32575 16 5.42857 16H11.4286ZM11.4286 3.71429V0H5.42857C4.95518 0 4.57143 0.38375 4.57143 0.857143V14C4.57143 14.4734 4.95518 14.8571 5.42857 14.8571H15.1429C15.6163 14.8571 16 14.4734 16 14V4.57143H12.2857C11.8143 4.57143 11.4286 4.18571 11.4286 3.71429ZM15.749 2.60611L13.3939 0.251036C13.2332 0.0903009 13.0151 1.18856e-06 12.7878 0L12.5714 0V3.42857H16V3.21218C16 2.98486 15.9097 2.76685 15.749 2.60611Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.d103ea5c7505956db382ede639ef9476.svg";
export { ForwardRef as ReactComponent };